module.exports = __webpack_public_path__ + "img/image-3.dfb1223f.webp";